import {
  GptSlot,
  GeneralSize,
  GptImpressionViewableEvent,
  GptSlotOnloadEvent,
  GptSlotRenderEndedEvent,
  GptSlotRequestedEvent,
  GptSlotResponseReceivedEvent,
  GptSlotVisibilityChangedEvent,
  SingleSizeArray,
  GptSlotRenderEndedEventData,
  GptSlotRequestedEventData,
  GptSlotOnloadEventData,
  GptImpressionViewableEventData, GptSlotResponseReceivedEventData, GptSlotVisibilityChangedEventData,
  SingleSize
} from "./googleTypes";
import { Bidder } from "./bidder";
import { BidderHelper } from "./bidderHelper";
import { dateUtil, deviceUtil, logUtil } from "@repo/lib-common";
import { PbjsAdUnit } from "./pbjsTypes";
import { SlotRenderEndedSubject, SlotRenderEndedSubjectData } from "./eventSubjects/slotRenderEndedSubject";
import { DomainSubjectCallback } from "../eventSubjects/domainSubject";



//#region ad unit subtypes -->
export abstract class AdSizes {
  private static single_300x600: SingleSize = [300, 600];
  private static single_300x250: SingleSize = [300, 250];
  private static single_970x250: SingleSize = [970, 250];
  private static single_1x1: SingleSize = [1, 1];

  public static general_1x1: GeneralSize = [AdSizes.single_1x1];
  public static general_300x600: GeneralSize = [AdSizes.single_300x250];
  public static general_970x250: GeneralSize = [AdSizes.single_970x250];
  public static prebid_970x250: SingleSizeArray = [AdSizes.single_970x250];
  public static prebid_300x600: SingleSizeArray = [AdSizes.single_300x600];
  public static prebid_300x250: SingleSizeArray = [AdSizes.single_300x250];

  public static desktop_PageSkin_Top: GeneralSize = AdSizes.general_1x1;//[[1, 1], [1230, 40]];
  public static desktop_Masthead: GeneralSize = [[1, 1], [728, 90], [960, 90], [960, 250], [970, 90], [970, 250]];
  public static desktop_Tower: GeneralSize = [[1, 1], [120, 600], [160, 600], [300, 600]];
  public static desktop_GenBodyBox: GeneralSize = [[300, 600], [300, 250], [250, 250], [200, 200]];
  public static desktop_Gen_300x250: GeneralSize = [[200, 200], [250, 250], [300, 50], [300, 100], [300, 250], [320, 50], [320, 100], [320, 150]];
  public static desktop_Widget_300x250: GeneralSize = [[336, 280], [300, 250], [250, 250], [200, 200]];
  public static desktop_Widget_336x280: GeneralSize = [[336, 280], [300, 250], [250, 250], [200, 200]];
  public static desktop_GenBodyBox_300x250: GeneralSize = [[300, 250], [250, 250], [200, 200]];

  public static desktop_Intext: GeneralSize = [[1, 1], [200, 200], [250, 250], [300, 250], [336, 280], [640, 480]];
  public static desktop_And_Mobile_Nativo: GeneralSize = [[1, 1], 'fluid'];

  public static mobile_Generic: GeneralSize = [[1, 1], [200, 200], [250, 250], [300, 50], [300, 100], [300, 250], [320, 50], [320, 100], [320, 150]];


}

export const enum AdUnitTypeEnum {
  banner = "banner",
  outOfPage_Interstitial = "interstitial",
  outOfPage_BottomAnchor = "bottom-anchor",
  outOfPage_TopAnchor = "top-anchor",


}

/** ad unit special use case besides type */
export const enum AdUnitSpecialUseCaseEnum {
  none = "none",
  nativo = "nativo",
  intext = "intext",
  rewarded = "rewarded",
  loadMore = "loadMore"
}


/** ad loading strategy */
export const enum AdLoadingStrategyTypeEnum {
  /** default value, if none ad unit will not be requested */
  none = "none",
  /** used for above the fold (viewport) initial single request architecture */
  sra = "sra",

  trigger = "trigger",
  /** used for below the fold (viewport) lazy load (intersection observer based) */
  intersectionObserverBasedLazyLoad = "intersection_observer_lazy_load",

  /** used for google publisher tag lazy load architecture (not implemented) */
  gptLazyLoad = "gpt_lazy_load",

  /** used for initializing ad unit after dom content loaded */
  domContentLoaded = "dom_content_loaded"


}
//#endregion

//#region states
export class PbjsState {
  private _isPbjsInitialRequestExecuted = false;
  public get isPbjsInitialRequestExecuted() {
    return this._isPbjsInitialRequestExecuted;
  }
  public set isPbjsInitialRequestExecuted(value) {
    this._isPbjsInitialRequestExecuted = value;
  }
  private _isPbjsAdUnitAdded_TimeStame?: number | undefined;
  public get isPbjsAdUnitAdded_TimeStame(): number | undefined {
    return this._isPbjsAdUnitAdded_TimeStame;
  }
  public set isPbjsAdUnitAdded_TimeStame(value: number | undefined) {
    this._isPbjsAdUnitAdded_TimeStame = value;
  }
  private _isPbjsAdUnitAdded = false;
  public get isPbjsAdUnitAdded() {
    return this._isPbjsAdUnitAdded;
  }
  public set isPbjsAdUnitAdded(value) {
    this.isPbjsAdUnitAdded_TimeStame = dateUtil.dateTime.getTimeStamp();
    this._isPbjsAdUnitAdded = value;
  }

  private _lastRequestedAt?: number | undefined;
  public get lastRequestedAt(): number | undefined {
    return this._lastRequestedAt;
  }
  public set lastRequestedAt(value: number | undefined) {
    this._lastRequestedAt = value;
  }
}

export class GptState {

  private _isDefineSlotExecuted = false;
  public get isDefineSlotExecuted() {
    return this._isDefineSlotExecuted;
  }
  public set isDefineSlotExecuted(value) {
    this._isDefineSlotExecuted = value;
  }

  private _isDisplaySlotExecuted = false;
  public get isDisplaySlotExecuted() {
    return this._isDisplaySlotExecuted;
  }
  public set isDisplaySlotExecuted(value) {
    this._isDisplaySlotExecuted = value;
  }

  private _refreshSlotExecutedAt?: number | undefined;
  public get refreshSlotExecutedAt(): number | undefined {
    return this._refreshSlotExecutedAt;
  }
  public set refreshSlotExecutedAt(value: number | undefined) {
    this._refreshSlotExecutedAt = value;
  }

  private _isRefreshSlotExecuted = false;
  public get isRefreshSlotExecuted() {
    return this._isRefreshSlotExecuted;
  }
  public set isRefreshSlotExecuted(value) {
    this.refreshSlotExecutedAt = dateUtil.dateTime.getTimeStamp();
    this._isRefreshSlotExecuted = value;
  }

  //#region gpt events
  private _gptSlotRenderEndedEvent?: GptSlotRenderEndedEvent | undefined;
  public get gptSlotRenderEndedEvent(): GptSlotRenderEndedEvent | undefined {
    return this._gptSlotRenderEndedEvent;
  }
  public set gptSlotRenderEndedEvent(value: GptSlotRenderEndedEvent | undefined) {
    this._gptSlotRenderEndedEvent = value;
  }

  private _gptSlotRequestedEvent?: GptSlotRequestedEvent | undefined;
  public get gptSlotRequestedEvent(): GptSlotRequestedEvent | undefined {
    return this._gptSlotRequestedEvent;
  }
  public set gptSlotRequestedEvent(value: GptSlotRequestedEvent | undefined) {
    this._gptSlotRequestedEvent = value;
  }

  private _gptSlotOnloadEvent?: GptSlotOnloadEvent | undefined;
  public get gptSlotOnloadEvent(): GptSlotOnloadEvent | undefined {
    return this._gptSlotOnloadEvent;
  }
  public set gptSlotOnloadEvent(value: GptSlotOnloadEvent | undefined) {
    this._gptSlotOnloadEvent = value;
  }

  private _gptImpressionViewableEvent?: GptImpressionViewableEvent | undefined;
  public get gptImpressionViewableEvent(): GptImpressionViewableEvent | undefined {
    return this._gptImpressionViewableEvent;
  }
  public set gptImpressionViewableEvent(value: GptImpressionViewableEvent | undefined) {
    this._gptImpressionViewableEvent = value;
  }

  private _gptSlotResponseReceivedEvent?: GptSlotResponseReceivedEvent | undefined;
  public get gptSlotResponseReceivedEvent(): GptSlotResponseReceivedEvent | undefined {
    return this._gptSlotResponseReceivedEvent;
  }
  public set gptSlotResponseReceivedEvent(value: GptSlotResponseReceivedEvent | undefined) {
    this._gptSlotResponseReceivedEvent = value;
  }

  private _gptSlotVisibilityChangedEvent?: GptSlotVisibilityChangedEvent | undefined;
  public get gptSlotVisibilityChangedEvent(): GptSlotVisibilityChangedEvent | undefined {
    return this._gptSlotVisibilityChangedEvent;
  }
  public set gptSlotVisibilityChangedEvent(value: GptSlotVisibilityChangedEvent | undefined) {
    this._gptSlotVisibilityChangedEvent = value;
  }

  //#endregion

}

export class AutoRefreshState {

  private _isCompleted = false;
  public get isCompleted() {
    return this._isCompleted;
  }
  public set isCompleted(value) {
    this._isCompleted = value;
  }

  private _completedAt?: number | undefined;
  public get completedAt(): number | undefined {
    return this._completedAt;
  }
  public set completedAt(value: number | undefined) {
    this._completedAt = value;
  }

}
export class IntersectionObserverState {

  private _isCompleted = false;
  public get isCompleted() {
    return this._isCompleted;
  }
  public set isCompleted(value) {
    this.completedAt = dateUtil.dateTime.getTimeStamp();
    this._isCompleted = value;
  }

  private _completedAt?: number | undefined;
  public get completedAt(): number | undefined {
    return this._completedAt;
  }
  public set completedAt(value: number | undefined) {
    this._completedAt = value;
  }

}
//#endregion

export class AdUnitState {
  private _isProcessLockEnabled: boolean = false;
  public get isProcessLockEnabled(): boolean {
    return this._isProcessLockEnabled;
  }
  public set isProcessLockEnabled(value: boolean) {
    this._isProcessLockEnabled = value;
  }
}

/** ad unit main builder class contains google and header bidding */
export class AdUnit {

  static builder(type: AdUnitTypeEnum): AdUnit {
    return new AdUnit(type);
  }
  constructor(type: AdUnitTypeEnum) {
    this.type = type;
  }




  //#region simple states

  gptState = new GptState();
  pbjsState = new PbjsState();
  autoRefreshState = new AutoRefreshState();
  objectState = new AdUnitState();
  intersectionObserverState = new IntersectionObserverState();






  mustBeInitialized() {
    if (this.objectState.isProcessLockEnabled) {
      logUtil.consoleLog(`adUnit ${this.divId} mustBeInitialized=false objectState.isProcessLockEnabled:`, this.objectState.isProcessLockEnabled);
      return false;
    }
    if (this.gptState.isDefineSlotExecuted) {
      logUtil.consoleLog(`adUnit ${this.divId} mustBeInitialized=false gptState.isDefineSlotExecuted:`, this.gptState.isDefineSlotExecuted);
      return false;
    }
    if (this.gptState.isDisplaySlotExecuted) {
      logUtil.consoleLog(`adUnit ${this.divId} mustBeInitialized=false gptState.isDisplaySlotExecuted:`, this.gptState.isDisplaySlotExecuted);
      return false;
    }

    if (this.isPreBidEnabled && this.pbjsState.isPbjsAdUnitAdded) {
      logUtil.consoleLog(`adUnit ${this.divId} mustBeInitialized=false pbjsState.isPbjsAdUnitAdded:`, this.pbjsState.isPbjsAdUnitAdded);
      return false;
    }
    if (this.isPreBidEnabled && this.pbjsState.isPbjsInitialRequestExecuted) {
      logUtil.consoleLog(`adUnit ${this.divId} mustBeInitialized=false pbjsState.isPbjsInitialRequestExecuted:`, this.pbjsState.isPbjsInitialRequestExecuted);
      return false;
    }
    if (this.gptSlot) {
      logUtil.consoleLog(`adUnit ${this.divId} mustBeInitialized=false gptSlot:`, this.gptSlot);
      return false;
    }
    logUtil.consoleLog(`adUnit ${this.divId} mustBeInitialized=true`);
    return true;
  }

  private refreshTimeLimitInMs = 60 * 1000; //in milliseccond
  canBeRefreshed() {
    if (!this.isAutoRefreshEnabled) {
      logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=false, isAutoRefreshEnabled:`, this.isAutoRefreshEnabled);
      return false;
    }
    if (this.objectState.isProcessLockEnabled) {
      logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=false, objectState.isProcessLockEnabled:`, this.objectState.isProcessLockEnabled);
      return false;
    }
    if (this.gptState.isRefreshSlotExecuted && this.gptState.refreshSlotExecutedAt) {
      const timeDif = dateUtil.dateTime.getTimeStamp() - this.gptState.refreshSlotExecutedAt;
      if (timeDif < this.refreshTimeLimitInMs) {
        logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=false, gptState.refreshSlotExecutedAt timeDif:`, timeDif);
        return false;
      }
    }
    if (this.mustBeInitialized()) {
      logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=false, mustBeInitialized:`, this.mustBeInitialized());
      return false;
    }

    if (this.gptState.gptImpressionViewableEvent && this.gptState.gptImpressionViewableEvent.eventData) {
      const timeDif = dateUtil.dateTime.getTimeStamp() - this.gptState.gptImpressionViewableEvent.createdAt.getTime();
      if (timeDif < this.refreshTimeLimitInMs) {
        logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=false, gptState.gptImpressionViewableEvent.createdAt timeDif:`, timeDif);
        return false;
      }
    }
    if (this.gptState.gptSlotVisibilityChangedEvent && this.gptState.gptSlotVisibilityChangedEvent.eventData
      && this.gptState.gptSlotVisibilityChangedEvent.eventData?.inViewPercentage <= 0) {
      logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=false, gptState.gptSlotVisibilityChangedEvent.eventData.inViewPercentage:`, this.gptState.gptSlotVisibilityChangedEvent.eventData?.inViewPercentage);
      return false;
    }

    if (this.intersectionObserverState.isCompleted && this.intersectionObserverState.completedAt) {
      const timeDif = dateUtil.dateTime.getTimeStamp() - this.intersectionObserverState.completedAt;
      if (timeDif < this.refreshTimeLimitInMs) {
        logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=false, intersectionObserverState.completedAt timeDif:`, timeDif);
        return false;
      }
    }

    if (this.autoRefreshState.isCompleted && this.autoRefreshState.completedAt) {
      const timeDif = dateUtil.dateTime.getTimeStamp() - this.autoRefreshState.completedAt;
      if (timeDif < this.refreshTimeLimitInMs) {
        logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=false, autoRefreshState.completedAt timeDif:`, timeDif);
        return false;
      }
    }

    logUtil.consoleLog(`adUnit ${this.divId} canBeRefreshed=true`, this);

    return true;




  }



  //#endregion

  //#region props
  type: AdUnitTypeEnum;
  isEnabled: boolean = true;
  adUnitPath!: string;
  sizes: GeneralSize = [];
  divId!: string;
  divStyle?: string;
  isCollapseEmptyDivEnabled: boolean = false;
  loadingStrategy: AdLoadingStrategyTypeEnum = AdLoadingStrategyTypeEnum.none;
  gptSlot?: GptSlot;
  isAutoRefreshEnabled_WhenPageUrlChanged: boolean = false;
  isAutoRefreshEnabled: boolean = false;
  specialUseCaseType: AdUnitSpecialUseCaseEnum = AdUnitSpecialUseCaseEnum.none;
  specialUseCaseIndex: number = 0;
  setSpecialUseCaseIndex(val: number) {
    this.specialUseCaseIndex = val;
    return this;
  }


  setSpecialUseCase(useCaseType: AdUnitSpecialUseCaseEnum) {
    this.specialUseCaseType = useCaseType;
    return this;
  }

  setIsEnabled(value: boolean): AdUnit {
    this.isEnabled = value;
    return this;
  }
  setAdUnitPath(value: string): AdUnit {
    this.adUnitPath = value;
    return this;
  }
  setSizes(value: GeneralSize): AdUnit {
    this.sizes = value;
    return this;
  }
  setDeviceType(deviceTypes: deviceUtil.DeviceTypeArray) {
    this.allowedDevices = deviceTypes;
    return this;
  }



  setDivId(value: string): AdUnit {
    this.divId = value;
    return this;
  }
  setDivStyleAfterRequest(divStyle: string) {
    this.divStyle = divStyle;
    return this;
  }
  setCollapseEmptyDivEnabled(value: boolean): AdUnit {
    this.isCollapseEmptyDivEnabled = value;
    return this;
  }

  setLoadingStrategy(value: AdLoadingStrategyTypeEnum): AdUnit {
    this.loadingStrategy = value;
    return this;
  }

  setIsAutoRefreshEnabled(value: boolean): AdUnit {
    this.isAutoRefreshEnabled = value;
    return this;
  }

  setIsAutoRefreshEnabled_WhenPageUrlChanged(value: boolean): AdUnit {
    this.isAutoRefreshEnabled_WhenPageUrlChanged = value;
    return this;
  }


  setType(value: AdUnitTypeEnum): AdUnit {
    this.type = value;
    return this;
  }
  setGptSlot(value: GptSlot) {
    this.gptSlot = value;
    return this;
  }
  //#endregion



  //#region prebid -->
  /** prebid AdUnit object to be used for ad request
   * @link https://docs.prebid.org/dev-docs/adunit-reference.html#ad-unit-reference
   *
   * */
  pbjsAdUnit?: PbjsAdUnit;
  bidderHelper?: BidderHelper;
  isPreBidEnabled = false;
  prebidSizeLimits: SingleSizeArray = [];
  calculatedBidders?: Array<Bidder>;
  allowedDevices: deviceUtil.DeviceTypeArray = [];


  setIsPrebidEnabled(value: boolean): AdUnit {
    this.isPreBidEnabled = value;
    return this;
  }

  setPrebidSizeLimits(sizes: SingleSizeArray) {
    this.prebidSizeLimits = sizes;
    return this;
  }
  setBidders(bidders: Array<Bidder>): AdUnit {
    this.calculatedBidders = bidders;
    return this;
  }
  setBidderHelper(bidderHelper: BidderHelper) {
    this.bidderHelper = bidderHelper;
    return this;
  }
  //#endregion

  //#region subjects -->
  private slotRenderEndedSubject = new SlotRenderEndedSubject();
  onSlotRenderEnded(fn: DomainSubjectCallback<SlotRenderEndedSubjectData>) {
    this.slotRenderEndedSubject.subscribe(fn);
    return this;
  }
  //#endregion

  //#region gpt event data setters -->

  setGptSlotRenderEndedEventData(data: GptSlotRenderEndedEventData) {

    this.gptState.gptSlotRenderEndedEvent = new GptSlotRenderEndedEvent(data);
    const subjectData = new SlotRenderEndedSubjectData();
    subjectData.isEmpty = data.isEmpty;
    subjectData.divId = this.divId;
    this.slotRenderEndedSubject.setDataAndTrigger(subjectData);

    return this;
  }

  setGptSlotRequestedEventData(data: GptSlotRequestedEventData) {
    this.gptState.refreshSlotExecutedAt = dateUtil.dateTime.getTimeStamp();
    this.gptState.gptSlotRequestedEvent = new GptSlotRequestedEvent(data);
    return this;
  }


  setGptSlotOnloadEventData(data: GptSlotOnloadEventData) {
    this.gptState.gptSlotOnloadEvent = new GptSlotOnloadEvent(data);
    return this;
  }


  setGptImpressionViewableEventData(data: GptImpressionViewableEventData) {
    this.gptState.gptImpressionViewableEvent = new GptImpressionViewableEvent(data);
    return this;
  }


  setGptSlotResponseReceivedEventData(data: GptSlotResponseReceivedEventData) {
    this.gptState.refreshSlotExecutedAt = dateUtil.dateTime.getTimeStamp();
    this.gptState.gptSlotResponseReceivedEvent = new GptSlotResponseReceivedEvent(data);
    return this;
  }


  setGptSlotVisibilityChangedEventData(data: GptSlotVisibilityChangedEventData) {
    this.gptState.gptSlotVisibilityChangedEvent = new GptSlotVisibilityChangedEvent(data);
    return this;
  }

  //#endregion



  isDivStyleApplied = false;
  applyDivStyle() {
    if (this.isDivStyleApplied) return;
    if (this.divStyle !== undefined) {
      const elem = document.getElementById(this.divId);
      if (elem) {
        elem.setAttribute('style', this.divStyle);
        this.isDivStyleApplied = true;
        return;
      }
      logUtil.consoleWarn(`${this.divId} elem is not found and style will not be applied`);
    } else {
      logUtil.consoleWarn(`${this.divId} elem is found but style will not be applied style:`, this.divStyle);
    }
  }

  /** Build and validate adUnit*/
  build() {
    if (this.loadingStrategy === AdLoadingStrategyTypeEnum.none) {
      logUtil.throwError(`AdLoadingStrategy is not defined for ${this.divId} ${this.adUnitPath}`);
      return this;
    }
    if (!this.adUnitPath) {
      logUtil.consoleError(`adUnitPath not defined for ${this.divId} ${this.adUnitPath}`);
      return this;
    }
    if (!this.divId && this.type == AdUnitTypeEnum.banner) {
      logUtil.throwError(`divId not defined`);
      return this;
    }

    if (this.isPreBidEnabled) {
      // this.calculatedBidders = this.bidderHelper?.filterBySizeArray(this.prebidSizeLimits);
      this.calculatedBidders = this.bidderHelper?.filterBySizeAndDevice(this.prebidSizeLimits, this.allowedDevices);
      if (!(this.calculatedBidders && this.calculatedBidders?.length > 0)) {
        logUtil.throwError(`bidders could not be calculated for ${this.divId} ${this.adUnitPath}`);
        return this;
      }
      const prebid = {} as PbjsAdUnit;
      prebid.code = this.adUnitPath;
      prebid.mediaTypes = { banner: { sizes: this.prebidSizeLimits } };
      prebid.bids = this.calculatedBidders.map(q => q.toBidObj());
      this.pbjsAdUnit = prebid;
    }

    return this;
  }




}

